export default __webpack_public_path__ + "static/media/card-1.a3a65c2a.webp";